// 引入element插件，也可以不用，看具体项目需求
import { Message, MessageBox } from "element-ui";
import { method, } from "@/common/common.js"
// 引入路由，登录失效时跳转回登录页
import router from "../router/index";
// 文件处理方法
// import { file } from "./file";
import { getToken, } from "@/api/cookie.js"

const axios = require("axios");
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
let opWindow = false;
// 超时时间
const fetch = axios.create({
  timeout: 60 * 1000 * 10
});

fetch.interceptors.request.use(
  config => {
    // 设置token
    const token = getToken();

    const recordToken = localStorage.getItem('recordToken');

    if (token) {
      config.headers.Authorization = `${token}`;
    }
    if(recordToken) {
      config.headers.RecordToken = `${recordToken}`;
    }
    let method = config.method.toLowerCase();
    if (method === 'post') {
      let data = config.data;
      if (data) {
        config.data = data;
        config.headers.Accept = 'application/json';
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

fetch.interceptors.response.use(
  res => {
    console.log();
    // 判断返回数据类型，如果是文件，则执行下载；否则判断接口是否请求成功，具体状态与后端协商，这里以res.data.success举例
    if (
      res.headers["content-type"] === "application/vnd.ms-excel;charset=UTF-8"
    ) {
      // 下载文件
      // file(res);
    } else if (res.data.code == "1001") {
      MessageBox.alert('当前登录失效！请重新登陆！', '提示', {
        confirmButtonText: '确定',
        center: true,
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        method.loginOut();
      }).catch(() => {});
      return {
        code: '1001',
        data: null,
        msg: '登录失效',
      }
    } else {
      return res.data;
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default fetch;
